import CONST from '../../../../../includes/primitives/_constant_trion'
export default {
  data: () => ({
    HOST: CONST.HOST_NAME_RESOURCE + '/resources',
        
    canvasForm: null,
    canvasContents: null,
    rawData:    null,
    filterData: null,

    revision:   null,
    area:       null,
    table:      null,
    columns:    null,
    scroll:     null,

    current:    {},
    cutoff:     null,
    toggle:     'ON',
    animationInterval: null,
  }),


  computed: {
    ready2draw() {
      return (
        this.DataItems.length > 0 &&
        Object.keys(this.Canvas).length > 0
      )
    },
  },


  methods: {
    set_Gradients() {

      
    },

  }
}